import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useContext, useState } from 'react';
import { TodoContexts } from '../context/TodoContext';

export default function UpdateCommponentPop({StateOpen,Closeprop,Todo}) {
   const {todoses,settodos}=useContext(TodoContexts);
   const [inputtitle,settitle]=useState(Todo.title);
   const [inputdetails,setdetails]=useState(Todo.details);

function handlupdate(){
const DateUpdate=todoses.map((d)=>{
if(d.id==Todo.id){
d.title=inputtitle;
d.details=inputdetails;
}
return d;
});
localStorage.setItem('todo',JSON.stringify(DateUpdate));
settodos(DateUpdate);
Closeprop();
}
   
  return (

      <Dialog fullWidth open={StateOpen} onClose={Closeprop} sx={{ direction:'rtl' }}>
        <DialogTitle>تعديل المهمة</DialogTitle>
        <DialogContent>
        
          <form onSubmit={(e)=>{
e.preventDefault();
   handlupdate();
          }

            } id="subscription-form">
           
            <TextField
              autoFocus
              margin="dense"
              id="name"
              name="title"
              label="العنوان"
              type="text"
              fullWidth
              variant="standard"
              value={ inputtitle }
              onChange={(event)=>{
            settitle(event.target.value)
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              name="title"
              label="الوصف"
              type="text"
              fullWidth
              variant="standard"
              value={ inputdetails}
              onChange={(event)=>{
              setdetails(event.target.value)
              }}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={Closeprop}>اغلاق</Button>
          <Button type="submit" form="subscription-form">
            تاكيد
          </Button>
        </DialogActions>
      </Dialog>

  );
}
